module.exports = __webpack_public_path__ + "static/media/cypress.c571b86a.png";